/**
 * Delivery Management container
 */
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import adminActions from '../Admin/actions';
import DeliveryManagement from '../../Components/DeliveryManagement/DeliveryManagement';
import {
  loadingSelector,
  errorSelector,
  vendorSelector,
  vendorCountSelector,
} from '../Admin/selectors';
import Actions from './actions';
import { locationsSelector } from './selectors';

const mapStateToProps = (state) => ({
  loading: loadingSelector(state),
  locations: locationsSelector(state),
  error: errorSelector(state),
  vendors: vendorSelector(state),
  vendorCount: vendorCountSelector(state),
});

const mapDispatchToProps = (dispatch) => ({
  fetchVendors: (search) => dispatch(adminActions.fetchVendors(search)),
  getLocations: () => dispatch(Actions.getLocations()),
  createLocation: (location) => dispatch(Actions.createLocation(location)),
  updateLocation: (locationId, location) =>
    dispatch(Actions.updateLocation(locationId, location)),
});

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(DeliveryManagement),
);
